import requestService from "./request";

let expertSenderTrackService = function(tourCriteriaForTourRequest, callback, url) {
	var ajax,
		options = {
			url:'/marketing/expertsender/searchTrack',
			data:tourCriteriaForTourRequest
		};

	ajax = requestService(options, callback);

	return ajax;
};

export default expertSenderTrackService;